/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {DefaultTooltipContent} from 'recharts/lib/component/DefaultTooltipContent';
import { LineChart,Line, XAxis, YAxis, CartesianGrid, Tooltip, Label, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
      // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
      return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
  
    const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
        const updated = { ...item }
        updated.value = setCurrencyFormat(Number(item?.value).toFixed(2), true);
        return updated;
    })    
    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
  };

const SalesByChannelChart = ({ dir, showTitle, companyBasedOn,
    dataToShow, height, allCategories}) => {
    const thisMonthData = {};
    const currentDataByYear = {};
   
    const sortByMonth = (arr) => {
          const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
          arr.sort((a, b) =>
              months.indexOf(a.month)
                   - months.indexOf(b.month)
          );
          return arr
          
    }
    // dataToShow.map((item, eleIndex) => (
    //     dataToPlot.push({
    //         day: item.day,
    //         amount: item?.Amount,
    //     })
    // ))
    // dataToShow?.map((item) => {
    //     const updated = { ...item };
    //     const { data } = updated
    //     updated.data = sortByMonth(item?.data)
    //     return updated
    // })
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF'.split('');
        let fillColor = '#';
        for (let i = 0; i < 6; i += 1) {
            fillColor += letters[Math.floor(Math.random() * 16)];
        }
        return fillColor;
    }

    return (      
        <ResponsiveContainer height={height}>
        <LineChart
            data={dataToShow}
            margin={{
                top: 0, right: 0, left: 25, bottom: 0,
            }}
        >
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <XAxis dataKey="currentMonthDataKey" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                tickFormatter={item => setCurrencyFormat(item, true)}
                width={90}
                allowDataOverflow
            />
            
            <Tooltip content={<CustomTooltip />} />
            {/* <Tooltip formatter={value => setCurrencyFormat(value, true)} /> */}
            <Legend />
            {allCategories && Object.keys(allCategories).map((categ, ind) => (
                <Line key={categ} dot={false} type="monotone" dataKey={categ.toString()} 
                stroke={getRandomColor()} strokeWidth={1} />                
            ))}
            {/* {dataToShow?.map((label, lineIndex) => (
            <Line dot={false} type="monotone" dataKey="Amount" data={label.innerData} 
            name={label.title} key={label.title} stroke={getRandomColor()} strokeWidth={1} /> */}
        {/* ))} */}
        </LineChart>
    </ResponsiveContainer>   
    )
}

SalesByChannelChart.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShow: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    companyBasedOn: PropTypes.string.isRequired,
    allCategories: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
};

SalesByChannelChart.defaultProps = {
    showTitle: true
  }

export default React.memo(SalesByChannelChart);